import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type GlobalState = {
  isPageLoading?: boolean;
};

type GlobalAction = {
  setIsPageLoading: (isLoading: boolean) => void;
};

const defaultState: GlobalState = {
  isPageLoading: false,
};

export const useGlobalStore = create<GlobalState & GlobalAction>()(
  devtools(
    immer((set) => ({
      ...defaultState,
      setIsPageLoading(isLoading) {
        set((state) => {
          state.isPageLoading = isLoading;
        });
      },
    })),
    {
      name: 'Global Store',
      enabled: true,
    },
  ),
);
